import TextInput from '@carvana/ds-text-input';
import { InputProps } from '@carvana/ds-text-input';
const LABEL = 'zip code';

export default function ZipInput({ id = LABEL, ...props }: InputProps) {
  return (
    <TextInput
      data-testid="zipcode-form-input"
      id={id}
      label="ZIP code"
      maxLength={5}
      minLength={5}
      name="zipcode"
      pattern="[0-9]{5}"
      type="tel"
      title="Please enter a valid zip code."
      {...props}
    />
  );
}
